import { addNewAbcAccountPayload } from '../../../interfaces/abc';
import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/abc/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_abc',
  );
}

export async function addNewAbcAccount(sessionId: string, accountPayload: addNewAbcAccountPayload) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(`${process.env.REACT_APP_API_PATH}/connections/abc`, requestOptions);
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/abc/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_get_abc',
  );
}
